module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("iqdke"))).then(() => parcelRequire('d0iPb'));